import { Box, Button, Icon, Text } from "@chakra-ui/react";
import {MdWhatsapp} from 'react-icons/md'

export function Footer(){
  return (
    <Box bg={'white'} mb={'8px'} height={'24px'} display={'flex'} justifyContent={'center'}>
      <Text textAlign={'center'} fontWeight={'bold'}>GOPASS - SUPORTE <Button as={'a'} variant={'unstyled'} color={'blue'} target="_blank" href={`https://wa.me/5544997150332?text=${encodeURI('Olá, preciso de suporte!')}`}>CLIQUE AQUI</Button> - <Icon as={MdWhatsapp} /> TEL: (44) 99715-0332</Text>
    </Box>
  )
}